import React, { useEffect, useState, lazy, Suspense } from 'react';
import {getVideoGallery, getHeaderNotification,  getFaqsData, getHomeAttractionsData, getHomeHeroBannerData, getHomeOffersData, getStoryBehindVishwarooData, getVisitorTestimonialData, getLatestHappeningsData, getHomeModalData} from './../utils/endpoints';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import {Helmet} from "react-helmet";
import { Container } from 'react-bootstrap';

const MainBanner = lazy(() => import('./components/mainBanner'));
const Offers = lazy(() => import('./components/offers'));
const HeaderNotification = lazy(() => import('./components/headerNotification'));
const ExploreAttractions = lazy(() => import('./components/exploreAttractions'));
const StoryBehind = lazy(() => import('./components/storyBehind'));
const Testimonial = lazy(() => import('./components/testimonial'));
const Faqs = lazy(() => import('./components/faq'));
const LatestHappenings = lazy(() => import('./components/latestHappenings'));
const CustomModal = lazy(() => import('./components/CustomModal'));
const VideoSection = lazy(() => import ('./components/videoCollage'))

const Home = () => {
  const [headerNotificationData, setHeaderNotificationData] = useState(null);
  const [heroBannerData, setHeroBannerData] = useState(null);
  const [homeOffersData, setHomeOffersData] = useState(null);
  const [homeAttraction, setHomeAttraction] = useState(null);
  const [storyBehindVishwaroo, setStoryBehindVishwaroo] = useState(null);
  const [testimonial, setTestimonial] = useState(null);
  const [latestHappenings, setLatestHappenings] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [homeModalData, sethomeModalData] = useState(null);
  const [videoGalleryData, setvideoGalleryData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          heroBannerData,
          homeOffersData,
          homeAttraction,
          storyBehindVishwaroo,
          testimonial,
          faqs,
          latestHappenings,
          headerNotificationData,
          homeModalData,
          videoGalleryData
        ] = await Promise.all([
          getHomeHeroBannerData(),
          getHomeOffersData(),
          getHomeAttractionsData(null, 5),
          getStoryBehindVishwarooData(),
          getVisitorTestimonialData(null, 8),
          getFaqsData(),
          getLatestHappeningsData(null, 5),
          getHeaderNotification(),
          getHomeModalData(),
          getVideoGallery()
        ]);

        setHeroBannerData(heroBannerData);
        setHomeOffersData(homeOffersData);
        setHomeAttraction(homeAttraction);
        setStoryBehindVishwaroo(storyBehindVishwaroo);
        setTestimonial(testimonial);
        setFaqs(faqs);
        setLatestHappenings(latestHappenings);
        setHeaderNotificationData(headerNotificationData);
        sethomeModalData(homeModalData);
        setvideoGalleryData(videoGalleryData)

        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      {!homeModalData[0]?.acf?.ishidden && <CustomModal compData={homeModalData} />}
      <Helmet>
      <title>Statue of belief entry ticket price | world's tallest shiva statue</title>
      <link rel="preload" href={heroBannerData[0]?.acf?.desktopUrl} as="image"/>
      </Helmet>
      <Suspense fallback={<Loading />}>
        <Header />
        <MainBanner compData={heroBannerData} />
        <ExploreAttractions compData={homeAttraction} />
        <Offers compData={homeOffersData} />
        <VideoSection isDesktop={true} compData={videoGalleryData}/>
        <StoryBehind compData={storyBehindVishwaroo} />
        <Testimonial compData={testimonial} />
        <LatestHappenings compData={latestHappenings} />
        <Faqs compData={faQSlice.slice(0,5)} />
        <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;
